/* eslint-disable no-underscore-dangle */
/* eslint-disable indent */
import React, { useCallback, useEffect, useState } from 'react';
import { Message, Select } from '@alifd/next';
import { DatePicker, Modal, Form } from 'antd';
import moment from 'moment';
import axios from 'axios';
import {
  SyncOutlined,
  PlusOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons';
import commonhelper from '@/lib/commonhelper';
import locale from 'antd/lib/date-picker/locale/zh_TW';
import color from '@/styles/mobile/color';

import Stack from '@mui/material/Stack';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Tab from '@/components/UI/mobile/Tab';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import zhTw from 'date-fns/locale/zh-TW';
import { InputAdornment, TextField, Box } from '@mui/material';
import HeightChart from './heightChart';
import BloodChart from './bloodChart';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';

const Option = Select.Option;

const HealthList = () => {
  const { useForm, Item } = Form;
  const [form] = useForm();
  const userHealth = client.service('userHealth');
  const users = client.service('users');
  const [memberArr, setMemberArr] = useState([]);
  const [healthArr, setHealthArr] = useState([]);
  const [healthNewArr, setHealthNewArr] = useState([]);
  const [usersHouseholdNumbers, setUsersHouseholdNumbers] = useState([]);
  const [newestHealthArr, setNewestHealthArr] = useState([]);
  const [BloodChartObj, setBloodChartObj] = useState({});
  const [HeightChartObj, setHeightChartObj] = useState({});
  const [chartDate, setChartDate] = useState(moment());
  const [disableDate, setDisableDate] = useState([]);
  const [bodyDisableDate, setBodyDisableDate] = useState([]);
  const [BloodArr, setBloodArr] = useState([]);
  const [BloodObject, setBloodObject] = useState([]);
  const [BloodAvg, setBloodAvg] = useState({
    afternoonMinTemp: null,
    afternoonMaxTemp: null,
    morningMinTemp: null,
    morningMaxTemp: null,
  });
  const [HeightArr, setHeightArr] = useState([]);
  const [chartType, setChartType] = useState('date');
  const [selectName, setSelectName] = useState('');
  const [addDataDialog, setAddDataDialog] = useState(false);
  const [addDataStatus, setAddDataStatus] = useState('blood');
  const [addDataObject, setAddDataObject] = useState({
    createTime: moment().valueOf(),
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [downloadDialog, setDownloadDialog] = useState(false);
  const [uId, setUId] = useState('');
  const [tab, setTab] = useState(0);

  // 刷新頁面
  const serverDataUpdate = useCallback(
    async function serverDataUpdate() {
      await client.reAuthenticate().then((result1) => {
        setSelectName(result1.user.name);
        setUId(result1.user._id);
        setUsersHouseholdNumbers(
          !Object.prototype.hasOwnProperty.call(
            result1.user,
            'householdNumbers'
          ) || result1.user.householdNumbers.length === 0
            ? false
            : result1.user.householdNumbers
        );

        users
          .find({
            query: {
              householdNumbers: { $in: result1.user.householdNumbers },
              // f_password: { $exists: false },
              expireTime: { $exists: false },
            },
          })
          .then((res) => {
            console.log(result1);
            const nameArr = res.data.map((x) => x.name);
            const filterArr = nameArr.filter((i) => {
              if (i.match(RegExp(/住戶/))) {
                // 因為甄翫必須這樣改
                return i;
              } else {
                return false;
              }
            });
            const result = new Set([...filterArr, ...nameArr]);
            if (result1.user.keyboardAccount === '物業keyboard帳號')
              setSelectName(nameArr[0]);
            setMemberArr([...result]);
          })
          .catch((error) => {
            console.log('==user member find  fail:', error);
          });
        userHealth
          .find({
            query: {
              householdNumber: { $in: result1.user.householdNumbers },
              $sort: {
                createTime: -1,
              },
            },
          })
          .then((res) => {
            setHealthArr(res.data.filter((x) => x.name === result1.user.name)); // 找到該戶號目前用戶資料
            setHealthNewArr(res.data); // 找到該戶號全部用戶資料
            if (
              res.data.filter((x) => x.name === result1.user.name).length > 0
            ) {
              if (
                Object.prototype.hasOwnProperty.call(
                  result1.user,
                  'householdNumbers'
                )
              ) {
                axios('/ezcon/api/userHealthFindNewest', {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: {
                    householdNumber: result1.user.householdNumbers[0],
                    name: result1.user.name,
                  },
                })
                  .then((res1) => {
                    console.log('==userHealthFindNewest:', res1.data);
                    setNewestHealthArr(res1.data);
                  })
                  .catch((error) => {
                    console.log('==find user Error', error);
                  });
              } else {
                Message.error('尚未找到資料');
                setNewestHealthArr([]);
              }
            }
          })
          .catch((error) => {
            console.log('==userHealth find  fail:', error);
          });
      });
    },
    [userHealth, users]
  );

  useEffect(() => {
    if (!usersHouseholdNumbers) {
      Message.error('尚未開通戶號');
      return;
    }

    serverDataUpdate();
  }, [isUpdate, serverDataUpdate, usersHouseholdNumbers]);

  useEffect(() => {
    // transformFormat(healthArr)
    transformFormat2(healthArr);
  }, [healthArr, transformFormat2]);

  useEffect(() => {
    if (selectName !== '' && healthNewArr.length > 0) {
      const selectArr = healthNewArr.filter((x) => x.name === selectName); // 從全部用戶資料找到所選擇姓名資料
      transformFormat2(selectArr);
      setUId(selectArr[0]?.uId);

      if (selectArr && selectArr.length > 0) {
        axios('/ezcon/api/userHealthFindNewest', {
          method: 'POST',
          headers: { authorization: window.localStorage['feathers-jwt'] },
          data: {
            householdNumber: usersHouseholdNumbers[0],
            name: selectName,
          },
        })
          .then((res) => {
            console.log(res.data, '====UserHealth');
            setNewestHealthArr(res.data);
          })
          .catch((error) => {
            console.log('==find user Error', error);
          });
      } else {
        Message.error('尚未找到資料');
        setNewestHealthArr([]);
      }
    }
  }, [
    healthNewArr,
    selectName,
    transformFormat2,
    usersHouseholdNumbers,
    chartType,
  ]);

  const transformFormat2 = useCallback(
    function transformFormat2(tarArr) {
      // 體重
      let Weight = tarArr
        .filter((value) => Object.prototype.hasOwnProperty.call(value, '體重'))
        .map((x) => ({
          createTime: x.createTime,
          體重: x.體重,
          身高: x.身高,
          BMI: x.BMI,
          week:
            parseInt(moment(x.createTime).format('d'), 10) === 0
              ? 6
              : parseInt(moment(x.createTime).format('d'), 10) - 1,
        }));
      const dayArr = []; // 迴圈記天數 'YYYY/MM/DD'
      Weight = Weight.sort((a, b) => {
        return a - b;
      }); // 排序大到小
      setHeightArr(Weight);
      let numW = 0;
      let avgHeightTemp = 0;
      let avgWeightTemp = 0;
      let avgBMI = 0;

      const WeightData = Weight.map((e) => {
        const dayStr = moment(e.createTime).format('YYYY/MM/DD');
        if (!dayArr.includes(dayStr)) {
          // 沒有該天 保留資料並 加入該天字串
          dayArr.push(dayStr);

          numW = 1;
          avgHeightTemp = e.身高;
          avgWeightTemp = e.體重;
          avgBMI = parseInt(e.BMI, 10);

          // return false;
        } else {
          numW++;
          avgHeightTemp = avgHeightTemp + e.身高;
          avgWeightTemp = avgWeightTemp + e.體重;
          avgBMI = avgBMI + e.BMI;
        }
        return {
          身高: e.身高,
          體重: e.體重,
          BMI: e.BMI,
          createTime: e.createTime,
          numW,
          avgHeightTemp,
          avgWeightTemp,
          avgBMI,
          time: moment(e.createTime).format('YYYY/MM/DD'),
        };
      }).sort((a, b) => {
        return a.createTime - b.createTime;
      });
      const dayArr1 = []; // 迴圈記天數 'YYYY/MM/DD'
      const WeightAvg = WeightData.map((e) => {
        const dayStr = moment(e.createTime).format('YYYY/MM/DD');
        if (!dayArr1.includes(dayStr)) {
          // 沒有該天 保留資料並 加入該天字串
          dayArr1.push(dayStr);
          return {
            身高: Number(e.avgHeightTemp / e.numW),
            體重: Number(e.avgWeightTemp / e.numW),
            BMI: Number(e.avgBMI / e.numW),
            week:
              parseInt(moment(e.createTime).format('d'), 10) === 0
                ? 6
                : parseInt(moment(e.createTime).format('d'), 10) - 1,
            createTime: e.createTime,
            time: moment(e.createTime).format('YYYY/MM/DD'),
          };
        } else {
          return false;
        }
      })
        .filter((e) => e !== false)
        .reverse(); // 濾掉 跳過資料

      setBodyDisableDate(dayArr);
      if (chartType === 'month' || chartType === 'week') {
        setHeightChartObj(WeightAvg);
      } else {
        setHeightChartObj(Weight);
      }

      // 血壓
      let DB = tarArr
        .filter((value) =>
          Object.prototype.hasOwnProperty.call(value, '舒張壓')
        )
        .map((x) => ({
          createTime: x.createTime,
          收縮壓: x.收縮壓,
          舒張壓: x.舒張壓,
          脈拍數: x.脈拍數,
          time: moment(x.createTime).format('YYYY/MM/DD HH:mm:ss'),
        }));

      DB = DB.sort((a, b) => {
        return a - b;
      }); // 排序大到小
      console.log(DB);
      setBloodArr(DB);

      let num = 0;
      let avgMinTemp = 0;
      let avgMaxTemp = 0;
      let avgHeart = 0;
      if (chartType === 'month' || chartType === 'week') {
        const dayArr2 = []; // 迴圈記天數 'YYYY/MM/DD'
        const BloodData = DB.map((e) => {
          const dayStr = moment(e.createTime).format('YYYY/MM/DD');
          if (!dayArr2.includes(dayStr)) {
            console.log(dayArr2);
            // 沒有該天 保留資料並 加入該天字串
            dayArr2.push(dayStr);
            num = 1;
            avgMinTemp = e.舒張壓;
            avgMaxTemp = e.收縮壓;
            avgHeart = e.脈拍數;

            // return false;
          } else {
            console.log(dayArr2);
            num++;
            avgMinTemp = avgMinTemp + e.舒張壓;
            avgMaxTemp = avgMaxTemp + e.收縮壓;
            avgHeart = avgHeart + e.脈拍數;
          }
          return {
            minTemp: e.舒張壓,
            maxTemp: e.收縮壓,
            heart: e.脈拍數,
            createTime: e.createTime,
            num,
            avgMinTemp,
            avgMaxTemp,
            avgHeart,
            time: moment(e.createTime).format('YYYY-MM-DD HH:mm:mm'),
          };
        }).sort((a, b) => {
          return a.createTime - b.createTime;
        });
        console.log(dayArr2);
        setDisableDate(dayArr2);
        console.log(BloodData);
        const dayArr3 = []; // 迴圈記天數 'YYYY/MM/DD'
        const BloodAvg = BloodData.map((e) => {
          const dayStr = moment(e.createTime).format('YYYY/MM/DD');
          if (!dayArr3.includes(dayStr)) {
            // 沒有該天 保留資料並 加入該天字串
            dayArr3.push(dayStr);
            return {
              minTemp: Number((e.avgMinTemp / e.num).toFixed(1)),
              maxTemp: Number((e.avgMaxTemp / e.num).toFixed(1)),
              heart: Number((e.avgHeart / e.num).toFixed(1)),
              week:
                parseInt(moment(e.createTime).format('d'), 10) === 0
                  ? 6
                  : parseInt(moment(e.createTime).format('d'), 10) - 1,
              createTime: e.createTime,
              time: moment(e.createTime).format('YYYY/MM/DD'),
              num: e.num,
            };
          } else {
            return false;
          }
        })
          .filter((e) => e !== false)
          .reverse(); // 濾掉 跳過資料
        console.log(BloodAvg);
        setBloodChartObj(BloodAvg);
      } else if (chartType === 'date') {
        const dayArr3 = []; // 迴圈記天數 'YYYY/MM/DD'
        const dayArr4 = [];
        const BloodAvg = DB.map((e) => {
          const dayStr = moment(e.createTime).format('YYYY/MM/DD HH:00');
          if (!dayArr3.includes(dayStr)) {
            // 沒有該天 保留資料並 加入該天字串
            dayArr3.push(dayStr);
            dayArr4.push(moment(e.createTime).format('YYYY/MM/DD'));
            return {
              minTemp: e.舒張壓,
              maxTemp: e.收縮壓,
              heart: e.脈拍數,
              createTime: e.createTime,
              time: moment(e.createTime).format('YYYY/MM/DD'),
              num: 1,
            };
          } else {
            return false;
          }
        })
          .filter((e) => e !== false)
          .reverse(); // 濾掉 跳過資料
        setBloodChartObj(BloodAvg);
        setDisableDate(dayArr4);
      }
    },
    [chartType]
  );

  useEffect(() => {
    if (BloodArr.length > 0) {
      // 計算本週平均值
      let avgMorningMinTemp = 0;
      let avgMorningMaxTemp = 0;
      let avgAfternoonMinTemp = 0;
      let avgAfternoonMaxTemp = 0;
      let MorningNum = 0;
      let AfterNum = 0;
      console.log(BloodArr);
      const newBloodAvg = BloodArr.filter((e) => {
        if (chartType === 'week') {
          if (
            e.createTime >= moment(chartDate).startOf('W').valueOf() &&
            e.createTime <= moment(chartDate).endOf('W').valueOf()
          ) {
            if (parseInt(moment(e.createTime).format('HH'), 10) < 12) {
              MorningNum++;
              avgMorningMinTemp += e.舒張壓;
              avgMorningMaxTemp += e.收縮壓;
            } else {
              AfterNum++;
              avgAfternoonMinTemp += e.舒張壓;
              avgAfternoonMaxTemp += e.收縮壓;
            }
            return e;
          }
        } else if (chartType === 'month') {
          if (
            e.createTime >= moment(chartDate).startOf('month').valueOf() &&
            e.createTime <= moment(chartDate).endOf('month').valueOf()
          ) {
            if (parseInt(moment(e.createTime).format('HH'), 10) < 12) {
              MorningNum++;
              avgMorningMinTemp += e.舒張壓;
              avgMorningMaxTemp += e.收縮壓;
            } else {
              AfterNum++;
              avgAfternoonMinTemp += e.舒張壓;
              avgAfternoonMaxTemp += e.收縮壓;
            }
            return e;
          }
        } else if (chartType === 'date') {
          if (
            e.createTime >= moment(chartDate).startOf('day').valueOf() &&
            e.createTime <= moment(chartDate).endOf('day').valueOf()
          ) {
            if (parseInt(moment(e.createTime).format('HH'), 10) < 12) {
              MorningNum++;
              avgMorningMinTemp += e.舒張壓;
              avgMorningMaxTemp += e.收縮壓;
            } else {
              AfterNum++;
              avgAfternoonMinTemp += e.舒張壓;
              avgAfternoonMaxTemp += e.收縮壓;
            }
            return e;
          }
        }
      });
      console.log(newBloodAvg);
      setBloodObject(newBloodAvg);
      if (MorningNum > 0) {
        setBloodAvg((pre) => ({
          ...pre,
          morningMinTemp: (avgMorningMinTemp / MorningNum).toFixed(1),
          morningMaxTemp: (avgMorningMaxTemp / MorningNum).toFixed(1),
        }));
      } else {
        setBloodAvg((pre) => ({
          ...pre,
          morningMinTemp: null,
          morningMaxTemp: null,
        }));
      }

      if (AfterNum > 0) {
        setBloodAvg((pre) => ({
          ...pre,
          afternoonMinTemp: (avgAfternoonMinTemp / AfterNum).toFixed(1),
          afternoonMaxTemp: (avgAfternoonMaxTemp / AfterNum).toFixed(1),
        }));
      } else {
        setBloodAvg((pre) => ({
          ...pre,
          afternoonMinTemp: null,
          afternoonMaxTemp: null,
        }));
      }
    }
  }, [BloodArr, chartDate, HeightChartObj, chartType, HeightArr]);

  function BMI(val) {
    if (val === 0) {
      return '尚無數值';
    } else if (val < 18.5) {
      return '過輕';
    } else if (val >= 18.5 && val < 24) {
      return '正常';
    } else if (val >= 24 && val < 27) {
      return '過重';
    } else if (val >= 27 && val < 30) {
      return '輕度肥胖';
    } else if (val >= 30 && val < 35) {
      return '中度肥胖';
    } else if (val >= 35) {
      return '重度肥胖';
    }

    //  體重過輕 BMI<18.5
    //  健康體位 18.5<=BMI<24
    // 體位異常
    // 過重：24<=BMI<27
    // 輕度肥胖：27 <= BMI < 30
    // 中度肥胖：30 <= BMI < 35
    // 重度肥胖：BMI >= 35	男性：>= 90 公分
    // 女性：>= 80 公分
  }

  function BMIStyles(val) {
    // 0=>BMIColor0
    // 過輕=>BMIColor1
    // 正常=>BMIColor2
    // 過重=>BMIColor3
    // 輕度肥胖=>BMIColor4
    // 中度肥胖=>BMIColor5
    // 重度肥胖=>BMIColor6
    // 尚無數值=>BMIColor7
    if (val === 0) {
      // 尚無數值
      const result = styles.BMIColor0;
      return result;
    } else if (val < 18.5) {
      // 過輕
      const result = styles.BMIColor1;
      return result;
    } else if (val >= 18.5 && val < 24) {
      // 正常
      const result = styles.BMIColor2;
      return result;
    } else if (val >= 24 && val < 27) {
      // 過重
      const result = styles.BMIColor3;
      return result;
    } else if (val >= 27 && val < 30) {
      // 輕度肥胖
      const result = styles.BMIColor4;
      return result;
    } else if (val >= 30 && val < 35) {
      // 中度肥胖
      const result = styles.BMIColor5;
      return result;
    } else if (val >= 35) {
      // 重度肥胖
      const result = styles.BMIColor6;
      return result;
    } else if (val === '尚無數值') {
      // 尚無數值
      const result = styles.BMIColor7;
      return result;
    }
  }

  function Blood(a, b) {
    // a=>收縮壓
    // b=>舒張壓
    if (a === 0 && b === 0) {
      return '尚無數值';
    }
    if (b < 90) {
      if (a < 140) {
        if (b < 80) {
          if (a < 120) {
            return '適中';
          } else if (a >= 120 && a < 130) {
            return '正常';
          } else if (a >= 130 && a < 140) {
            return '正常偏高';
          }
        } else if (b >= 80 && b < 85) {
          if (a < 120) {
            return '正常';
          } else if (a >= 120 && a < 130) {
            return '正常';
          } else if (a >= 130 && a < 140) {
            return '正常偏高';
          }
        } else if (b >= 85 && b < 90) {
          return '正常偏高';
        }
      } else {
        return '收縮期高血壓';
      }
    } else if (b >= 90 && b < 100) {
      if (a < 160) {
        return '第一期高血壓';
      } else if (a >= 160 && a < 180) {
        return '第二期高血壓';
      } else {
        return '第三期高血壓';
      }
    } else if (b >= 100 && b < 110) {
      if (a < 180) {
        return '第二期高血壓';
      } else {
        return '第三期高血壓';
      }
    } else if (b >= 110) {
      return '第三期高血壓';
    }
  }

  function BloodStyles(a, b) {
    // a=>收縮壓
    // b=>舒張壓
    // 0=>bloodColor0
    // 適中=>bloodColor1
    // 正常=>bloodColor2
    // 正常偏高=>bloodColor3
    // 收縮期高血壓=>bloodColor4
    // 第一期高血壓=>bloodColor5
    // 第二期高血壓=>bloodColor6
    // 第三期高血壓=>bloodColor7
    if (a === 0 && b === 0) {
      // 0
      const result = styles.bloodColor0;
      return result;
    }
    if (b < 90) {
      if (a < 140) {
        if (b < 80) {
          if (a < 120) {
            // 適中
            const result = styles.bloodColor1;
            return result;
          } else if (a >= 120 && a < 130) {
            // 正常
            const result = styles.bloodColor2;
            return result;
          } else if (a >= 130 && a < 140) {
            // 正常偏高
            const result = styles.bloodColor3;
            return result;
          }
        } else if (b >= 80 && b < 85) {
          if (a < 120) {
            // 正常
            const result = styles.bloodColor2;
            return result;
          } else if (a >= 120 && a < 130) {
            // 正常
            const result = styles.bloodColor2;
            return result;
          } else if (a >= 130 && a < 140) {
            // 正常偏高
            const result = styles.bloodColor3;
            return result;
          }
        } else if (b >= 85 && b < 90) {
          // 正常偏高
          const result = styles.bloodColor3;
          return result;
        }
      } else {
        // 收縮期高血壓
        const result = styles.bloodColor4;
        return result;
      }
    } else if (b >= 90 && b < 100) {
      if (a < 160) {
        // 第一期高血壓
        const result = styles.bloodColor5;
        return result;
      } else if (a >= 160 && a < 180) {
        // 第二期高血壓
        const result = styles.bloodColor6;
        return result;
      } else {
        // 第三期高血壓
        const result = styles.bloodColor7;
        return result;
      }
    } else if (b >= 100 && b < 110) {
      if (a < 180) {
        // 第二期高血壓
        const result = styles.bloodColor6;
        return result;
      } else {
        // 第三期高血壓
        const result = styles.bloodColor7;
        return result;
      }
    } else if (b >= 110) {
      // 第三期高血壓
      const result = styles.bloodColor7;
      return result;
    }
  }
  const customWeekStartEndFormat = (value) => {
    if (chartType === 'week') {
      return `${value.startOf('W').format('MM/DD')} ~ ${value
        .endOf('W')
        .format('MM/DD')}`;
    } else if (chartType === 'month') {
      return `${value.format('YYYY年MM月')} `;
    } else if (chartType === 'date') {
      return `${value.format('YYYY/MM/DD')} `;
    }
  };

  const handleDownload = async (value) => {
    try {
      const res = await axios.get('/ezcon/api/userHealthExcel', {
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
        params: {
          timeStart: value.timeStart.startOf('day').valueOf(),
          timeEnd: value.timeEnd.endOf('day').valueOf(),
          name: value.name,
          householdNumber: usersHouseholdNumbers[0],
        },
      });
      const link = document.createElement('a');
      link.href = res.data.filePath;
      link.download = `${value.name}_${value.timeStart.format(
        'YYYYMMDD'
      )}-${value.timeEnd.format('YYYYMMDD')}身體量測資料.xlsx`;
      link.click();
      setDownloadDialog(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Box
      sx={{
        width: '100vw',
        height: 'calc(100vh - var(--header-height))',
        position: 'fixed',
        top: 'var(--header-height)',
        overflowY: 'auto',
      }}
    >
      <div className={styles.mobileHealth}>
        <div className={styles.mobileFixBackground} />
        <div className={styles.householdBox}>
          <div className={styles.householdTextBox}>
            <div className={styles.householdText}>戶號</div>

            <SyncOutlined
              className={styles.reloadIcon}
              onClick={() => {
                commonhelper.pageReload();
              }}
            />
          </div>
          <div className={styles.household}>
            {usersHouseholdNumbers.length > 0
              ? usersHouseholdNumbers[0]
              : '尚無開通戶號'}
          </div>
        </div>
        <div className={styles.selectBox}>
          <div className={styles.selectLeft}>
            <div className={styles.selectLeftText}>選擇帳戶：</div>
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <Select
                // hasClear 不拿掉app時會有點2下bug
                className={styles.mobileSelect}
                value={selectName}
                placeholder="請選擇成員"
                dataSource={memberArr}
                onChange={(value) => {
                  setSelectName(value);
                }}
              />
              <CloudDownloadOutlined
                className={styles.downloadIcon}
                style={{ marginRight: 10 }}
                onClick={() => {
                  setDownloadDialog(true);
                  form.setFieldsValue({
                    name: selectName,
                  });
                }}
              />
            </div>
          </div>
        </div>
        <>
          <div className={styles.main}>
            <Tab
              options={['最新一筆', '血壓量測', '身高體重量測']}
              onChange={setTab}
            />
            {tab === 0 && (
              <div className={styles.cardContainer}>
                <div className={styles.titleBox}>
                  <div className={styles.titleBoxImg}>
                    <img
                      className={styles.titleImg}
                      src="icon/ic_blood pressure.svg"
                      alt="血壓icon"
                    />
                    <div className={styles.measureText}>血壓量測</div>
                  </div>
                  <div className={styles.time}>
                    {newestHealthArr[0]?.血壓日期 && newestHealthArr.length > 0
                      ? moment(newestHealthArr[0]?.血壓日期).format(
                          'YYYY/MM/DD'
                        )
                      : null}
                  </div>
                </div>
                <div className={styles.measureBox}>
                  <div className={styles.measureBox2}>
                    <div className={styles.measureBox2Text}>收縮壓</div>
                    <div className={styles.measureBox2Text2}>
                      {newestHealthArr && newestHealthArr.length > 0
                        ? `${newestHealthArr[0].收縮壓}mmHg`
                        : '尚無數值'}
                    </div>
                  </div>
                  <div className={styles.measureBox3}>
                    <div className={styles.measureBox2Text}>舒張壓</div>
                    <div className={styles.measureBox2Text2}>
                      {newestHealthArr && newestHealthArr.length > 0
                        ? `${newestHealthArr[0].舒張壓}mmHg`
                        : '尚無數值'}
                    </div>
                  </div>
                  <div className={styles.measureBox3}>
                    <div className={styles.measureBox2Text}>脈拍數</div>
                    <div className={styles.measureBox2Text2}>
                      {newestHealthArr && newestHealthArr.length > 0
                        ? `${newestHealthArr[0].脈拍數}次/分鐘`
                        : '尚無數值'}
                    </div>
                  </div>
                </div>
                <div
                  className={
                    newestHealthArr && newestHealthArr.length > 0
                      ? BloodStyles(
                          newestHealthArr[0].收縮壓,
                          newestHealthArr[0].舒張壓
                        )
                      : styles.BloodStylesNone
                  }
                >
                  {newestHealthArr && newestHealthArr.length > 0
                    ? Blood(
                        newestHealthArr[0].收縮壓,
                        newestHealthArr[0].舒張壓
                      )
                    : '尚無數值'}
                </div>

                <div className={styles.titleBox}>
                  <div className={styles.titleBoxImg}>
                    <img
                      className={styles.titleImg}
                      src="icon/ic_body scale.svg"
                      alt="身高體重icon"
                    />
                    <div className={styles.measureText}>身高體重量測</div>
                  </div>
                  <div className={styles.time}>
                    {newestHealthArr[0]?.身高日期 && newestHealthArr.length > 0
                      ? moment(newestHealthArr[0]?.身高日期).format(
                          'YYYY/MM/DD'
                        )
                      : null}
                  </div>
                </div>
                <div className={styles.measureBox}>
                  <div className={styles.measureBox2}>
                    <div className={styles.measureBox2Text}>身高</div>
                    <div className={styles.measureBox2Text2}>
                      {newestHealthArr && newestHealthArr.length > 0
                        ? `${newestHealthArr[0].身高}cm`
                        : '尚無數值'}
                    </div>
                  </div>
                  <div className={styles.measureBox3}>
                    <div className={styles.measureBox2Text}>體重</div>
                    <div className={styles.measureBox2Text2}>
                      {newestHealthArr && newestHealthArr.length > 0
                        ? `${newestHealthArr[0].體重}kg`
                        : '尚無數值'}
                    </div>
                  </div>
                  <div className={styles.measureBox3}>
                    <div className={styles.measureBox2Text}>BMI</div>
                    <div className={styles.measureBox2Text2}>
                      {newestHealthArr && newestHealthArr.length > 0
                        ? `${newestHealthArr[0].BMI}kg/㎡`
                        : '尚無數值'}
                    </div>
                  </div>
                </div>
                <div
                  className={
                    newestHealthArr && newestHealthArr.length > 0
                      ? BMIStyles(newestHealthArr[0].BMI)
                      : styles.BMIStylesNone
                  }
                >
                  {newestHealthArr && newestHealthArr.length > 0
                    ? BMI(newestHealthArr[0].BMI)
                    : '尚無數值'}
                </div>
              </div>
            )}
            {tab === 1 && (
              <>
                <div className={styles.chartTitle}>
                  <div className={styles.chartTitleRow}>
                    <Select
                      value={chartType}
                      onChange={(value) => setChartType(value)}
                    >
                      <Option value="date">日</Option>
                      <Option value="week">週</Option>
                      <Option value="month">月</Option>
                    </Select>
                    <DatePicker
                      allowClear={false}
                      className={styles.datePicker}
                      defaultValue={chartDate}
                      size="large"
                      onChange={(value) => {
                        setChartDate(value);
                      }}
                      picker={chartType}
                      locale={locale}
                      format={(value) =>
                        customWeekStartEndFormat(value, chartType)
                      }
                      disabledDate={(current) => {
                        return !disableDate.includes(
                          current.format('YYYY/MM/DD')
                        );
                      }}
                    />
                    <PlusOutlined
                      className={styles.downloadIcon}
                      style={{ marginRight: 10 }}
                      onClick={() => {
                        setAddDataDialog(true);
                        setAddDataStatus('blood');
                      }}
                    />
                  </div>
                </div>
                <BloodChart
                  BloodChartObj={BloodChartObj}
                  chartType={chartType}
                  chartDate={chartDate}
                />
                <div className={styles.cardContainer}>
                  <>
                    <div className={styles.titleBox}>
                      <div className={styles.titleBoxImg}>
                        <img
                          className={styles.titleImg}
                          src="icon/ic_blood pressure.svg"
                          alt="血壓icon"
                        />
                        <div className={styles.measureText}>血壓量測</div>
                      </div>

                      <div className={styles.time}>
                        {chartType === 'week' &&
                          `${moment(chartDate)
                            .startOf('W')
                            .format('MM/DD')}～${moment(chartDate)
                            .endOf('W')
                            .format('MM/DD')}`}
                        {chartType === 'month' &&
                          moment(chartDate).format('YYYY年MM月')}
                        {chartType === 'date' &&
                          moment(chartDate).format('YYYY/MM/DD')}
                      </div>
                    </div>
                    <div className={styles.measureBox}>
                      <div
                        className={styles.measureBox4}
                        style={{
                          borderRight: '1px solid #8b8b8b',
                        }}
                      >
                        <div className={styles.measureBox4Text2}>
                          {BloodAvg.morningMaxTemp === null
                            ? '--'
                            : `${BloodAvg.morningMaxTemp}`}
                          /{' '}
                          {BloodAvg.morningMinTemp === null
                            ? '--'
                            : `${BloodAvg.morningMinTemp}`}
                        </div>
                        <div className={styles.measureBox4Text}>
                          {chartType === 'week' && '本週'}
                          {chartType === 'month' && '本月'}
                          {chartType === 'date' && '本日'}
                          上午平均血壓
                        </div>
                      </div>
                      <div className={styles.measureBox4}>
                        <div className={styles.measureBox4Text2}>
                          {BloodAvg.afternoonMaxTemp === null
                            ? '--'
                            : `${BloodAvg.afternoonMaxTemp}`}
                          /{' '}
                          {BloodAvg.afternoonMinTemp === null
                            ? '--'
                            : `${BloodAvg.afternoonMinTemp}`}
                        </div>
                        <div className={styles.measureBox4Text}>
                          {chartType === 'week' && '本週'}
                          {chartType === 'month' && '本月'}
                          {chartType === 'date' && '本日'}下午平均血壓
                        </div>
                      </div>
                    </div>
                  </>
                </div>
                {BloodObject.map((list) => {
                  return (
                    <div className={styles.cardContainer} key={list._id}>
                      <>
                        <div className={styles.titleBox}>
                          <div className={styles.titleBoxImg}></div>

                          <div className={styles.time}>
                            {moment(list.createTime).format(
                              'YYYY/MM/DD HH:mm:ss'
                            )}
                          </div>
                        </div>
                        <div className={styles.measureBox}>
                          <div className={styles.measureBox2}>
                            <div className={styles.measureBox2Text}>收縮壓</div>
                            {list.收縮壓 > 135 ? (
                              <div
                                className={styles.measureBox2Text2}
                                style={{ color: '#FF0000' }}
                              >
                                {list.收縮壓}mmHg
                              </div>
                            ) : (
                              <div className={styles.measureBox2Text2}>
                                {list.收縮壓}mmHg
                              </div>
                            )}
                          </div>
                          <div className={styles.measureBox3}>
                            <div className={styles.measureBox2Text}>舒張壓</div>
                            {list.舒張壓 > 85 ? (
                              <div
                                className={styles.measureBox2Text2}
                                style={{ color: '#FF0000' }}
                              >
                                {list.舒張壓}mmHg
                              </div>
                            ) : (
                              <div className={styles.measureBox2Text2}>
                                {list.舒張壓}mmHg
                              </div>
                            )}
                          </div>
                          <div className={styles.measureBox3}>
                            <div className={styles.measureBox2Text}>脈拍數</div>
                            <div className={styles.measureBox2Text2}>
                              {list.脈拍數}次/分鐘
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            list.收縮壓 && list.舒張壓
                              ? BloodStyles(list.收縮壓, list.舒張壓)
                              : styles.BloodStylesNone
                          }
                        >
                          {list.收縮壓 && list.舒張壓
                            ? Blood(list.收縮壓, list.舒張壓)
                            : '尚無數值'}
                        </div>
                      </>
                    </div>
                  );
                })}
              </>
            )}
            {tab === 2 && (
              <>
                <div className={styles.chartTitle}>
                  <div className={styles.chartTitleRow}>
                    <Select
                      value={chartType}
                      onChange={(value) => {
                        setChartType(value);
                      }}
                    >
                      <Option value="date">日</Option>
                      <Option value="week">週</Option>
                      <Option value="month">月</Option>
                    </Select>
                    <DatePicker
                      className={styles.datePicker}
                      value={chartDate}
                      onChange={(value) => {
                        setChartDate(value);
                      }}
                      picker={chartType}
                      locale={locale}
                      format={(value) =>
                        customWeekStartEndFormat(value, chartType)
                      }
                      disabledDate={(current) => {
                        return !bodyDisableDate.includes(
                          current.format('YYYY/MM/DD')
                        );
                      }}
                      allowClear={false}
                    />
                    <PlusOutlined
                      className={styles.downloadIcon}
                      style={{ marginRight: 10 }}
                      onClick={() => {
                        setAddDataDialog(true);
                        setAddDataStatus('height');
                      }}
                    />
                  </div>
                </div>
                <HeightChart
                  HeightChartObj={HeightChartObj}
                  chartType={chartType}
                  chartDate={chartDate}
                />
                {HeightArr.map((list) => {
                  return (
                    <div className={styles.cardContainer} key={list._id}>
                      <div className={styles.titleBox}>
                        <div className={styles.titleBoxImg}>
                          <img
                            className={styles.titleImg}
                            src="icon/ic_body scale.svg"
                            alt="身高體重icon"
                          />
                          <div className={styles.measureText}>身高體重量測</div>
                        </div>

                        <div className={styles.time}>
                          {moment(list.createTime).format(
                            'YYYY/MM/DD HH:mm:ss'
                          )}
                        </div>
                      </div>
                      <div className={styles.measureBox}>
                        <div className={styles.measureBox2}>
                          <div className={styles.measureBox2Text}>身高</div>
                          <div className={styles.measureBox2Text2}>
                            {list.身高}cm
                          </div>
                        </div>
                        <div className={styles.measureBox3}>
                          <div className={styles.measureBox2Text}>體重</div>
                          <div className={styles.measureBox2Text2}>
                            {list.體重}kg
                          </div>
                        </div>
                        <div className={styles.measureBox3}>
                          <div className={styles.measureBox2Text}>BMI</div>

                          {list.BMI >= 24 || list.BMI < 18.5 ? (
                            <div
                              className={styles.measureBox2Text2}
                              style={{ color: '#FF0000' }}
                            >
                              {list.BMI}kg/㎡
                            </div>
                          ) : (
                            <div className={styles.measureBox2Text2}>
                              {list.BMI}kg/㎡
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className={
                          list.BMI ? BMIStyles(list.BMI) : styles.BMIStylesNone
                        }
                      >
                        {list.BMI ? BMI(list.BMI) : '尚無數值'}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </>
        {/* 手動新增資料 */}
        <Modal
          closable={false}
          mask={false}
          className={styles.modal2}
          open={addDataDialog}
          okText="送出"
          cancelText="取消"
          onOk={() => {
            if (
              (addDataObject?.收縮壓 &&
                addDataObject?.舒張壓 &&
                addDataObject?.脈拍數) ||
              (addDataObject?.身高 && addDataObject?.體重)
            ) {
              let newObject = {
                householdNumber: usersHouseholdNumbers[0],
                name: selectName,
                uId,
                ...addDataObject,
              };
              if (addDataStatus === 'height') {
                newObject = {
                  ...newObject,
                  BMI: (
                    newObject.體重 /
                    ((newObject.身高 / 100) * (newObject.身高 / 100))
                  ).toFixed(2),
                };
              } else {
                newObject = {
                  ...newObject,
                  平均血壓: 0,
                };
              }
              userHealth
                .create(newObject)
                .then(() => {
                  Message.success('新增成功');
                  setAddDataDialog(false);
                  setAddDataObject({
                    createTime: moment().valueOf(),
                  });
                  setIsUpdate((pre) => !pre);
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              Message.error('請輸入完整資料');
              // setAddDataDialog(false);
            }
          }}
          onCancel={() => {
            setAddDataDialog(false);
            setAddDataObject({
              createTime: moment().valueOf(),
            });
          }}
        >
          <div className={styles.previewContainer}>
            <div className={styles.subject}>
              新增{addDataStatus === 'blood' ? '血壓' : '身高體重'}
            </div>
            <div className={styles.householdBox}>
              <div className={styles.householdTextBox}>
                <div className={styles.householdText}>姓名</div>
              </div>
              <div className={styles.household}>{selectName}</div>
            </div>
            <div className={styles.titleContainer}>
              {addDataStatus === 'blood' ? (
                <>
                  <div className={styles.titleBox}>
                    <Stack spacing={3}>
                      <TextField
                        label="收縮壓"
                        type="number"
                        value={
                          addDataObject?.收縮壓 ? addDataObject.收縮壓 : ''
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">mmHg</InputAdornment>
                          ),
                        }}
                        onChange={(e) => {
                          const newObject = { ...addDataObject };
                          const value = e.target.value;
                          if (value !== '') {
                            newObject.收縮壓 = Number(value);
                          } else {
                            newObject.收縮壓 = '';
                          }
                          setAddDataObject(newObject);
                        }}
                      />
                    </Stack>
                  </div>
                  <div className={styles.titleBox}>
                    <Stack spacing={3}>
                      <TextField
                        label="舒張壓"
                        type="number"
                        value={
                          addDataObject?.舒張壓 ? addDataObject.舒張壓 : ''
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">mmHg</InputAdornment>
                          ),
                        }}
                        onChange={(e) => {
                          const newObject = { ...addDataObject };
                          const value = e.target.value;
                          if (value !== '') {
                            newObject.舒張壓 = Number(value);
                          } else {
                            newObject.舒張壓 = '';
                          }
                          setAddDataObject(newObject);
                        }}
                      />
                    </Stack>
                  </div>
                  <div className={styles.titleBox}>
                    <Stack spacing={3}>
                      <TextField
                        label="脈拍數"
                        type="number"
                        value={
                          addDataObject?.脈拍數 ? addDataObject.脈拍數 : ''
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              次/分鐘
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => {
                          const newObject = { ...addDataObject };
                          const value = e.target.value;
                          if (value !== '') {
                            newObject.脈拍數 = Number(value);
                          } else {
                            newObject.脈拍數 = '';
                          }
                          setAddDataObject(newObject);
                        }}
                      />
                    </Stack>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.titleBox}>
                    <Stack spacing={3}>
                      <TextField
                        label="身高"
                        type="number"
                        value={addDataObject?.身高 ? addDataObject.身高 : ''}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">cm</InputAdornment>
                          ),
                        }}
                        onChange={(e) => {
                          const newObject = { ...addDataObject };
                          const value = e.target.value;
                          if (value !== '') {
                            newObject.身高 = Number(value);
                          } else {
                            newObject.身高 = '';
                          }
                          setAddDataObject(newObject);
                        }}
                      />
                    </Stack>
                  </div>
                  <div className={styles.titleBox}>
                    <Stack spacing={3}>
                      <TextField
                        label="體重"
                        type="number"
                        value={addDataObject?.體重 ? addDataObject.體重 : ''}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">kg</InputAdornment>
                          ),
                        }}
                        onChange={(e) => {
                          const newObject = { ...addDataObject };
                          const value = e.target.value;
                          if (value !== '') {
                            newObject.體重 = Number(value);
                          } else {
                            newObject.體重 = '';
                          }
                          setAddDataObject(newObject);
                        }}
                      />
                    </Stack>
                  </div>
                </>
              )}
              <div className={styles.titleBox}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  adapterLocale={zhTw}
                >
                  <Stack spacing={3}>
                    <DateTimePicker
                      label="日期"
                      inputFormat="yyyy-MM-dd HH:mm"
                      value={moment(addDataObject?.createTime)}
                      onChange={(value) => {
                        const newObject = { ...addDataObject };
                        if (value !== '') {
                          newObject.createTime = value.valueOf();
                        } else {
                          newObject.createTime = moment().valueOf();
                        }
                        setAddDataObject(newObject);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Stack>
                </LocalizationProvider>
              </div>
            </div>
          </div>
        </Modal>

        {/* 下載excel資料 */}

        <Modal
          mask={false}
          closable={false}
          className={styles.modal2}
          open={downloadDialog}
          onCancel={() => {
            setDownloadDialog(false);
            form.resetFields();
          }}
          title="下載身體量測資料"
          onOk={() => form.submit()}
          okText="下載"
          okButtonProps={{
            style: {
              backgroundColor: color.ui.buttonPrimary,
              borderColor: color.ui.buttonPrimary,
            },
          }}
          cancelText="關閉"
          forceRender
        >
          <div className={styles.titleContainer}>
            <Form form={form} onFinish={handleDownload}>
              <Item
                label="姓名"
                name="name"
                rules={[
                  {
                    required: true,
                    message: '請選擇姓名',
                  },
                ]}
              >
                <Select
                  placeholder="請選擇成員"
                  dataSource={memberArr}
                  style={{ width: '100%' }}
                />
              </Item>
              <Item
                label="開始日期"
                name="timeStart"
                rules={[
                  {
                    required: true,
                    message: '請選擇下載開始時間',
                  },
                ]}
              >
                <DatePicker {...{ locale }} />
              </Item>
              <Item
                label="結束日期"
                name="timeEnd"
                rules={[
                  {
                    required: true,
                    message: '請選擇下載結束時間',
                  },
                ]}
              >
                <DatePicker {...{ locale }} />
              </Item>
            </Form>
          </div>
        </Modal>
      </div>
    </Box>
  );
};

export default HealthList;
